const React = require('react');
const { InputText } = require('components/inputText/inputText');
const Incomes = require('components/incomes/incomes');
import { formatText } from 'core/i18n';
import { RadioButton } from 'components/RadioButton/RadioButton';
const { InfoTooltip } = require('components/tooltip/tooltip');

class hasPEP extends React.Component {
    constructor(props) {
        super(props);
        this.buildIncomes = this.buildIncomes.bind(this);
    }

    buildIncomes() {
        const { userProfile, userProfileForm, formActions, disabled, handleSave } = this.props;

        return (
            <div className="fioc-account-type__has-pep__incomes">
                <Incomes
                    userProfile={userProfile}
                    userProfileForm={userProfileForm}
                    formActions={formActions}
                    handleSave={handleSave}
                    disabled={disabled}
                />
            </div>
        );
    }

    render() {
        const { userProfile, userProfileForm, formActions, profileModel, hideIncomes, disabled } = this.props;
        let viewPEP, incomes;
        const handleSave = this.props.handleSave;
        const modelName = profileModel.split('.')[1];

        if (!hideIncomes) {
            incomes = this.buildIncomes();
        }

        if (userProfile[profileModel.split('.')[1]] === 'true') {
            viewPEP = (
                <div className="fioc-account-type__has-pep__has-public-office-description">
                    <label className="form__haspublicofficedescription">
                        {formatText('field-hasPublicOfficeDescription')}
                    </label>
                    <InputText
                        profileModel={profileModel + '_details'}
                        validations={{
                            required: value => value && value.length,
                            valid: value => value.length <= 95,
                        }}
                        userProfile={userProfile}
                        userProfileForm={userProfileForm}
                        formActions={formActions}
                        isValidated={function () {
                            const publicCharges = {
                                answer: true,
                                details:
                                    typeof userProfile[modelName + '_details'] !== 'undefined' &&
                                    userProfile[modelName + '_details'] !== ''
                                        ? userProfile[modelName + '_details']
                                        : null,
                            };
                            handleSave('publicCharges', publicCharges);
                        }}
                        disabled={disabled}
                        autoCompleteField={false}
                        focusAnimated
                    />
                    {incomes}
                </div>
            );
        }

        return (
            <>
                <label>
                    {formatText('contentStepsTitles-pepsQuestion')}
                    <InfoTooltip text={formatText('tooltip-publicCharges')} newClassName="width" />
                </label>
                <RadioButton
                    profileModel={profileModel}
                    optionsList={[
                        {
                            label: formatText('field-hasPEPTrue'),
                            value: true,
                        },
                        {
                            label: formatText('field-hasPEPFalse'),
                            value: false,
                        },
                    ]}
                    userProfile={userProfile}
                    userProfileForm={userProfileForm}
                    formActions={formActions}
                    isUpdated={function () {
                        const modelName = profileModel.split('.')[1];
                        let details =
                            typeof userProfile[modelName + '_details'] !== 'undefined' &&
                            userProfile[modelName + '_details'] !== ''
                                ? userProfile[modelName + '_details']
                                : null;

                        if (userProfile[modelName] === 'false' && !hideIncomes && userProfile.is_income) {
                            details = null;
                            const incomes = {
                                work: false,
                                activities: false,
                                business: false,
                                realState: false,
                                other: null,
                            };
                            handleSave('income', incomes);
                            formActions.change('userProfile.' + modelName + '_details', '');
                            formActions.change('userProfile.is_income');
                            // Reset incomes
                            formActions.change('userProfile.income_work', false);
                            formActions.change('userProfile.income_activities', false);
                            formActions.change('userProfile.income_business', false);
                            formActions.change('userProfile.income_realState', false);
                            formActions.change('userProfile.income_description', null);
                            formActions.resetValidity('userProfile.income_description');
                            formActions.change('userProfile.income_other', false);
                        }

                        const publicCharges = {
                            answer: userProfile[modelName] === 'true',
                            details: details,
                        };
                        handleSave('publicCharges', publicCharges);
                    }}
                    focusAnimated
                    disabled={disabled}
                />
                {viewPEP}
            </>
        );
    }
}

module.exports = hasPEP;
